<template>
     <el-form :model="form">
        <el-form-item :label-width="formLabelWidth">    
            <el-upload
                class="upload-demo"
                drag
                :key="loadTime"
                :limit="1"
                :data="params"
                :action="uploadUrl"
                :show-file-list="true"
                :file-list="fileList"
                :on-success="handleImportSuccess"
                :before-upload="beforeImport">
                <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">
                        1.只能上传xls/xlsx文件，数据不能超过5000行、100列，文件大小不超过20M.<br>
                        2.请先使用导出功能导出表单模板，文件第一行为表单名称，第二行为表头(假如带有子表单字段，则第二、三行为表头)，表头为自定义表单的所有字段名称。
                        请按照所选模型表单名称填写，假如字段名重复，请修改表单字段名。<br>
                        3.<font color="red">暂不支持[文件]、[关联数据]、[子表单]这三类字段导入。</font>这三类数据导入时做空值处理。 
                        [选项]、[下拉]、[数据字典]，[业务分类]，[用户]，[部门]：这些字段内容需要在系统里存在才能导入。
                        [流水号]：假如excel内值填写为组件内的流水号名称，则导入时数据会根据配置规则自增生成。假如找不到则按excel所填值默认入库。</div>
            </el-upload>
            <div>
                <div><span><font size="3" >导入结果：<font :color="resultColor">{{ resultView }} </font><br> {{ importResult }}</font></span></div>
            </div>
        </el-form-item>
    </el-form> 
</template>

<script>
    import { API_APPLICATION_MODEL_IMPORT_FORM_EXCEL, API_EMPLOYEE_IMPORT_FORM_EXCEL } from '@/common/constants';

    export default {
        data () {
            return {
                loadTime: '',
                imageUrl: '',
                imagePath: '',
                fileForm: {},
                formLabelWidth: '30px',
                form: {
                    file: ''
                },
                fileList: [],
                params: {
                    modelId: '',
                    isEmployeeExtendData: false
                },
                resultView: '',
                resultColor: '',
                importResult: ''
            };
        },
        props: {
            isEmployeeData: {
                type: Boolean,
                default: false
            },
            isEmployeeExtendData: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            uploadUrl () {
                let url = '';
                let prefix = '';
                let env = process.env.NODE_ENV;
                if (env === 'production') {
                    prefix = '/bcbpm';
                }
                url = prefix + API_APPLICATION_MODEL_IMPORT_FORM_EXCEL;
                if (this.isEmployeeData) {
                    url = prefix + API_EMPLOYEE_IMPORT_FORM_EXCEL;
                }
                // console.log(url);
                return url;
            }
        },
        created () {
            this.resultColor = '';
            this.resultView = '';
            this.importResult = '';
            this.fileList = [];
        },
        methods: {
            initParam (param) {
                this.params.modelId = param.modelId;
                if (this.isEmployeeExtendData) {
                    this.params.isEmployeeExtendData = '1';
                } else {
                    this.params.isEmployeeExtendData = '0';
                }
                this.resultColor = '';
                this.resultView = '';
                this.importResult = '';
                this.fileList = [];
            },
            handleImportSuccess (res, file) {
                // console.log(res.data);
                if (res.data && res.data.length === 0) {
                    this.resultColor = 'green';
                    this.resultView = '导入成功';
                    setTimeout(() => {
                        this.$emit('importComplete');
                    }, 1000);
                } else {
                    this.resultColor = 'red';
                    this.resultView = '导入失败';
                    this.importResult = res.data;
                    this.loadTime = new Date().getTime();// 刷新组件，允许下一次上传文件导入
                }
            },
            beforeImport (file) {
                this.importResult = '';
                // console.log(file);
                const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (file.type === 'application/vnd.ms-excel');
                const isLt20M = (file.size / 1024 / 1024 < 20);
                // console.log(isExcel);
                // console.log(isLt20M);
                if (!isExcel) {
                    this.$message.error('导入文件只能是【xls】、【xlsx】格式!');
                }
                if (!isLt20M) {
                    this.$message.error('导入Excel文件大小不能超过 20MB!');
                }
                return isExcel && isLt20M;
            }
            // async importExcel() {
            //     //将信息保存数据库
            //     console.log(this.fileForm);
            //    // await updloadImg(this.fileForm);
            // }
        }
    };
</script>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/ExcelDataImport.vue